import {createAction} from "@reduxjs/toolkit";
import {ContainerDNUStatisticsSearchCriteria} from "@ots-frontend/ots-data";

export const setContainerDNUStatisticsSearchPageFilter = createAction<ContainerDNUStatisticsSearchCriteria>("ui/container-dnu-statistics-search-page/setFilter");
